import React, { useCallback } from 'react';
import classNames from 'classnames';
import CheckToggleField from 'components/CheckToggleField';
import { useTranslation } from 'react-i18next';
import { Field, useForm, useFormState } from 'react-final-form';
import { Button, Input } from 'ncoded-component-library';
import RichTextEditorField from 'components/RichTextEditorField';
import validations from 'validations';
import { CreateDataRoomShareableLinkForm } from 'models/ShareableLink';
import { INCLUDE_NDA_NAME } from '../ShareableLinkNda/ShareableLinkNda.component';
import UsersTCSelect from 'components/UsersTCSelect';
import useTermsAndConditionsTemplate, {
  INCLUDE_T_AND_C_NAME,
  T_AND_C_NAME,
} from './hooks/useTermsAndConditionsTemplate';

import './ShareableLinkTermsAndConditions.styles.scss';

type ShareableLinkTermsAndConditionsProps = {
  className?: string;
};

const ShareableLinkTermsAndConditions: React.FC<
  ShareableLinkTermsAndConditionsProps
> = (props) => {
  const { className } = props;

  const classes = classNames(
    'shareable-links-terms-and-conditions',
    'column',
    className,
  );

  const {
    values: { includeTermsAndConditionProtection },
  } = useFormState<CreateDataRoomShareableLinkForm>();
  const { change } = useForm();

  const { t } = useTranslation();

  const {
    selectedTemplate,
    statusLabel,
    showSaveTemplate,
    isNamingTemplate,
    templateName,
    isSaving,
    setTemplateName,
    onSelectTemplate,
    onStartNaming,
    onCancelNaming,
    onSaveTemplate,
  } = useTermsAndConditionsTemplate();

  const handleOnToogle = useCallback(
    (checked: boolean) => {
      if (checked) change(INCLUDE_NDA_NAME, false);
    },
    [change],
  );

  return (
    <div className={classes}>
      <Field
        name={INCLUDE_T_AND_C_NAME}
        type="checkbox"
        className="green-check-toggle"
        component={CheckToggleField}
        label={<span>{t('tAndC')}</span>}
        customOnChange={handleOnToogle}
      />

      {includeTermsAndConditionProtection && (
        <>
          <UsersTCSelect
            selectedId={selectedTemplate?._id ?? null}
            onSelect={onSelectTemplate}
          />

          <RichTextEditorField
            name={T_AND_C_NAME}
            required
            canExpand
            expandedModalLabel={t('tAndC')}
            validate={validations.richEditorRequired()}
          />

          {isNamingTemplate ? (
            <div className="shareable-links-terms-and-conditions__save-row">
              <Input
                autoFocus
                className="shareable-links-terms-and-conditions__name-input"
                value={templateName}
                placeholder={t('templateName')}
                onChange={({ target: { value } }) => setTemplateName(value)}
              />

              <Button variant="link" onClick={onCancelNaming}>
                {t('cancel')}
              </Button>
              <Button
                disabled={isSaving || !templateName.trim()}
                onClick={onSaveTemplate}
              >
                {t('save')}
              </Button>
            </div>
          ) : (
            <div className="shareable-links-terms-and-conditions__save-row">
              {statusLabel && (
                <span className="shareable-links-terms-and-conditions__status">
                  {statusLabel}
                </span>
              )}

              {showSaveTemplate && (
                <Button
                  variant="outline"
                  className="shareable-links-terms-and-conditions__save-button"
                  onClick={onStartNaming}
                >
                  {t('saveAsTemplate')}
                </Button>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ShareableLinkTermsAndConditions;
